import React, { useEffect } from 'react';
import './Home.css';
import { Header } from './components/Header';
import { IconicProjects } from './components/IconicProjects';
import { AboutSection } from '../about/components/AboutSection';
import { TrustedComments } from './components/TrustedComments';
import { ServiceJourney } from './components/ServiceJourney';
import { NavBar } from '../../utility/navBar/Navbar';
import { ServiceGrid } from '../service/components/ServiceGrid';
import { SingleProjectBanner } from './components/SingleProjectBanner';
import { Contact } from '../../utility/contact/Contact';
import { ServiceComparison } from './components/ServiceComparison';
import { SingleProjectBanner2 } from './components/SingleProjectBanner2';


export const Home = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0});
    }, []);

    return (
        <section className='home'>
            {/* <NavBar theme='light'/> */}
            <NavBar theme='light' />
            <Header />
            <IconicProjects />
            <AboutSection />
            <TrustedComments />
            <SingleProjectBanner projectId={2} />
            <ServiceGrid />
            <SingleProjectBanner2 />
            <ServiceJourney />
            <ServiceComparison />
            <Contact />
        </section>
    );
};
